const features = [
  {
    icon: 'ri-slideshow-line',
    title: '下拉式畅读',
    desc: '采用韩国Webtoon式下拉阅读设计，无需翻页即可连续浏览完整章节，滚动流畅自然，让阅读节奏不被打断。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日同步更新',
    desc: '日更作品超200部，热门连载与韩国上线几乎同步，完结作品一次性提供全集，追漫无需漫长等待。',
  },
  {
    icon: 'ri-palette-line',
    title: '韩系原画画质',
    desc: '严格保持原作分辨率与色彩，不压缩画质，细腻笔触与丰富色彩完整呈现，还原韩漫画师创作意图。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1080px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            布丁漫画为韩漫爱好者打造的专业阅读平台，三大核心优势提升阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 transition-all hover:-translate-y-1 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}